import { useState, useEffect } from 'react';
import { Autocomplete, TextField } from '@mui/material';
import PropTypes from 'prop-types';
import {
	getCountryListService,
	getAllCountryListService,
} from '../../Services/getCountryListService';
import { roles } from '../../Constants/Permission';
const AutoCompleteCountryDropdown = (props) => {
	const [countryList, setCountryList] = useState([]);

	const styles = {
		textField: {
			'& .MuiInputBase-root': {
				color: '#000',
				background: '#fff',
				flexShrink: 0,
				borderRadius: '.175rem',
				border: ' 1px #E5E5E5',
				padding: '0 1rem',
				width: `${props.width}`,
				height: `${props.height}`,
				//maxHeight: `2.5rem`,
			},
			'& input::placeholder': {
				fontSize: '14px',
			},

			'& .Mui-focused': {
				maxHeight: `unset`,
			},
		},
	};
	useEffect(() => {
		if (props?.country === 'All') {
			getAllCountryListService()
				.then((country) => {
					if (props?.multiple) {
						setCountryList([
							{
								countryisocode: 'All',
								countryName: 'All',
								countryNameInFrench: 'All',
							},
							,
							...country?.result,
						]);
					} else setCountryList(country?.result);
				})
				.catch((err) => {
					console.error(err);
					setCountryList([]);
				});
		} else if (props?.country === 'European') {
			getCountryListService()
				.then((country) => {
					if (props?.multiple) {
						setCountryList([
							{
								countryisocode: 'All',
								countryName: 'All',
								countryNameInFrench: 'All',
							},
							...country?.result,
						]);
					} else setCountryList(country?.result);
				})
				.catch((err) => {
					console.error(err);
					setCountryList([]);
				});
		} else if (props?.user === roles.MPC) {
			if (props?.multiple) {
				setCountryList([
					{
						countryisocode: 'All',
						countryName: 'All',
						countryNameInFrench: 'All',
					},
					,
					...props?.countries,
				]);
			} else setCountryList(props?.countries);
		}
	}, [props?.country, props?.countries]);
	let defaultValue;
	if (props?.defaultValue) {
		defaultValue = countryList.find(
			(country) => country.countryisocode === props?.defaultValue
		);
	}
	return (
		<Autocomplete
			id="autocomplete"
			noOptionsText={countryList?.length && 'no Matches Found'}
			options={countryList?.map((countryList) => countryList?.countryName)}
			sx={{ width: props?.multiple ? '30rem' : '100%' }}
			onChange={(event, newValue) => {
				props?.onChange(newValue);
			}}
			value={props?.value}
			size={'medium'}
			disableCloseOnSelect
			multiple={props?.multiple}
			limitTags={2}
			renderInput={(params) => (
				<TextField
					sx={styles.textField}
					{...params}
					placeholder={props?.placeholder}
					value={props?.value}
				/>
			)}
		/>
	);
};

AutoCompleteCountryDropdown.propTypes = {
	id: PropTypes.any,
	key: PropTypes.any,
	name: PropTypes.any,
	handleChange: PropTypes.any,
	placeholder: PropTypes.any,
};
export default AutoCompleteCountryDropdown;
